(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var body = document.querySelector('.policy-body');
  if (!body) return;
  var triggers = ['Note:', 'Important:', 'Please note', 'Please be aware', 'Warning:'];
  var paragraphs = body.querySelectorAll('p');
  paragraphs.forEach(function (p) {
    var text = p.textContent.trim();
    for (var i = 0; i < triggers.length; i++) {
      if (text.indexOf(triggers[i]) === 0) {
        var callout = document.createElement('div');
        callout.className = 'policy-callout';
        p.parentNode.insertBefore(callout, p);
        callout.appendChild(p);
        break;
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
